window.location.assign(process.env.REACT_APP_NEW_WEB_URL);
